<div class="au-dialog-container">
	@if (!data.title) {
		<h2 class="au-dialog-title">
			{{ 'delete' | translate }} {{ data.itemType | titlecase }}
		</h2>
	}
	@if (data.title) {
		<h2 class="au-dialog-title">
			{{ data.title | translate | titlecase }}
		</h2>
	}
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>
	<div class="au-dialog-content">
		<!-- prettier-ignore -->
		@if (!data.description) {
      <p class="au-dialog-description">
        {{ 'delete_confirm' | translate }} {{ data.itemType | titlecase }}?
      </p>
    }
		@if (data.description) {
			<p class="au-dialog-description" [innerHTML]="data.description"></p>
		}
	</div>
</div>
<mat-dialog-actions>
	<button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
	<button matRipple mat-flat-button class="error-btn" (click)="deleteApproved()">
		{{ data.confirmButton || ('delete' | translate) }}
	</button>
</mat-dialog-actions>
